
import ProductTechnicalFilters from '~/components/ProductTechnicalFilters'
import {
  BULB_FILTER_ORDER,
  hasActiveBulbFilters,
} from '~/utils/vehicleBulbList'

export default {
  name: 'VehicleBulbFilters',
  components: { ProductTechnicalFilters },
  props: {
    value: { type: Object, required: true },
    ranges: { type: Object, required: true },
    enabled: { type: Boolean, default: false },
    sheetId: { type: String, required: true },
    shown: { type: Number, default: 0 },
    total: { type: Number, default: 0 },
    missing: { type: Number, default: 0 },
  },
  data() {
    return {
      order: BULB_FILTER_ORDER,
      fadeStart: false,
      fadeEnd: false,
    }
  },
  computed: {
    active() {
      return hasActiveBulbFilters(this.value)
    },
    groupLabel() {
      return this.$t('components.vehicleBulbFilters.label')
    },
  },
  watch: {
    value() {
      this.$nextTick(this.updateFade)
    },
    enabled() {
      this.$nextTick(this.updateFade)
    },
  },
  mounted() {
    this.updateFade()
    window.addEventListener('resize', this.updateFade, { passive: true })
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateFade)
  },
  methods: {
    update(value) {
      this.$emit('input', value)
    },
    updateFade() {
      const scroller = this.$refs.scroller
      if (!scroller) return

      const { scrollLeft, scrollWidth, clientWidth } = scroller
      this.fadeStart = scrollLeft > 4
      this.fadeEnd = scrollLeft + clientWidth < scrollWidth - 4
    },
  },
}
